var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Search","transform":"translate(-1079 -5)"},[React.createElement("rect",{"id":"Rectangle_28","data-name":"Rectangle 28","width":"28","height":"28","transform":"translate(1079 5)","fill":"none","key":0}),React.createElement("path",{"id":"Path_10","data-name":"Path 10","d":"M18.47,17.828,14.322,13.68a8.234,8.234,0,1,0-.641.641l4.148,4.149ZM8.211,15.513a7.3,7.3,0,1,1,7.3-7.3,7.311,7.311,0,0,1-7.3,7.3","transform":"translate(1083.682 9.682)","fill":"#fff","stroke":"#fff","strokeWidth":"0.3","key":1})]));
}

SearchIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
